import React, { ReactNode } from "react";

const TwoColumns: React.FC<{ leftMinPx?: number, rightMinPx?: number, children: [ReactNode, ReactNode]}> = ({ leftMinPx, rightMinPx, children }) => {

  return (
    <div className={`flex flex-wrap`}>
      <div className={`flex-grow ${leftMinPx ? `min-w-[${leftMinPx}px]` : `min-w-[fit content]` } basis-1/3`}>
        { children[0] }
      </div>
      <div className={`flex-grow ${rightMinPx ? `min-w-[${rightMinPx}px]` : `min-w-[fit content]`} basis-2/3`}>
        { children[1] }
      </div>
    </div>
  )
}

export default TwoColumns;